<div class="copy-field" [class.copy-field-empty]="!hasValue" [class.copy-field-copied]="copied">
    <span class="copy-field-value" [class.copy-field-multiline]="multiline">{{ hasValue ? display : emptyText }}</span>
    <button type="button"
            class="copy-field-btn"
            *ngIf="hasValue"
            (click)="copy()"
            [attr.title]="copied ? 'Copiato!' : 'Copia'"
            [attr.aria-label]="copied ? 'Copiato' : 'Copia valore'">
        <i class="fa" [ngClass]="copied ? 'fa-check' : 'fa-copy'"></i>
    </button>
</div>
